// Bridge: expose to window.app for unconverted Phase 4 directives (.js files that cannot use imports)
declare global { interface Window { app: any } }
(window as any).app = (window as any).app || {};
(window as any).app.model = (window as any).app.model || {};
(window as any).app.model.project = (window as any).app.model.project || {};

export enum Status {
  Active = "active",
  Trial = "trial",
  Hibernate = "hibernate",
  Purged = "purged"
}
(window as any).app.model.project.Status = Status;
